document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const form = select.closest('form');
  const option = select.options[select.selectedIndex];
  const price = form && form.closest('[data-product-section]')?.querySelector('[data-product-price]');
  const button = form?.querySelector('[data-add-button]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'Add to cart' : 'Sold out';
  }
});

function initProductCarousels(root = document) {
  root.querySelectorAll('[data-product-carousel]').forEach(function (carousel) {
    if (carousel.dataset.carouselInitialized === 'true') return;

    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const group = carousel.closest('[data-carousel-group]') || carousel.closest('.section');
    const prev = group && group.querySelector('[data-carousel-prev]');
    const next = group && group.querySelector('[data-carousel-next]');
    const progressFill = carousel.querySelector('[data-carousel-progress-fill]');
    if (!viewport) return;

    carousel.dataset.carouselInitialized = 'true';

    function getStep() {
      const card = viewport.querySelector('.product-card');
      if (!card) return viewport.clientWidth;
      const track = viewport.querySelector('.product-carousel__track');
      const gap = track ? parseFloat(getComputedStyle(track).gap) || 0 : 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateCarouselState() {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const currentScroll = Math.max(0, Math.min(viewport.scrollLeft, maxScroll));

      if (prev) prev.disabled = currentScroll <= 2;
      if (next) next.disabled = maxScroll <= 2 || currentScroll >= maxScroll - 2;

      if (progressFill) {
        const progress = maxScroll <= 2 ? 1 : currentScroll / maxScroll;
        const displayProgress = maxScroll <= 2 ? 100 : Math.max(8, progress * 100);
        progressFill.style.width = displayProgress + '%';
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    viewport.addEventListener('scroll', updateCarouselState, { passive: true });
    window.addEventListener('resize', updateCarouselState);
    updateCarouselState();
  });
}

function initProductGallery(root = document) {
  root.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    if (gallery.dataset.galleryInitialized === 'true') return;

    const viewport = gallery.querySelector('[data-gallery-viewport]');
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    if (!viewport || !prev || !next || slides.length < 1) return;

    gallery.dataset.galleryInitialized = 'true';

    function getStep() {
      return viewport.clientWidth || 1;
    }

    function updateButtons() {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxScroll - 2;
    }

    prev.addEventListener('click', function () {
      viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });
}

function initTheme(root = document) {
  initProductCarousels(root);
  initProductGallery(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { initTheme(document); });
} else {
  initTheme(document);
}

document.addEventListener('shopify:section:load', function (event) {
  initTheme(event.target);
});
